import api from './api'
//import TokenService from './token.service'
//import SettingService from './setting.service'
import authHeader from './auth-header';
import store from '@/store'
import router from '@/router'

class AuthService {
  constructor() {
    this.logoutInprogress = false;
  }

  async login(user) {
    return api.post('/login_check', {
        username: user.username,
        password: user.password,
        keep_session_open: user.keep_session_open,
      })
      .then(response => {
        if (response.data.xsrf_token) {
          store.commit('token/save', {
              'xsrf': response.data.xsrf_token,
          })
        }

        return response.data
      });
  }

  async logout() {
    if(store.state.auth.status.loggedIn && this.logoutInprogress === false) {
      this.logoutInprogress = true

      const token = store.state.token

      if (token) {
        await api.post('/logout', {
          refresh_token: token.refreshToken,
        })
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser 
              // and an instance of http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
          })
        .finally(() => {
          store.dispatch('token/clear')
          store.dispatch('profil/clear')

          this.logoutInprogress = false

          router.push({ name: 'login' })
        })
      }
    }
  }

  resetPassword(email) {
    if(email) {
      api.post('/profil/reset-password', {
        email: email.email,
      }, authHeader())
      .then(response => {
          return response.data;
      })
      .catch(function (error) {
          console.log('Error', error.message);
        })
    }
  }

  newPassword(password, password_confirm) {
    if(password) {
      api.post('/profil/new-password', {
        token: password.token,
        password: password.password,
      }, authHeader())
      .then(response => {
          return response.data;
      })
      .catch(function (error) {
          console.log('Error', error.message);
        });
    }
  }
}

export default new AuthService();
